import Vue from 'vue'
import router from '../router'
import bus from '../javascript/bus'
import axios from 'axios'
import VueAxios from 'vue-axios'
import util from '@/javascript/util'
import payPublic from '@/javascript/payPublic.js'

import Bridge from '../javascript/JSbridge.js'
Vue.prototype.$bridge = Bridge

const ua = navigator.userAgent.toLowerCase()
let a
// android_client 安卓、 xyhl_ios ios
if (ua.match(/android_client/i) == "android_client") {
    a = 2
} else if (ua.match(/xyhl_ios/i) == "xyhl_ios") {
    a = 1
} else {
    a = false
}

Vue.use(VueAxios, axios)

if (payPublic.isClient()) {
    Vue.prototype.THE_CLIENT = true
} else {
    Vue.prototype.THE_CLIENT = false
}


/**
 * 图片地址
 * @type {string}
 */
Vue.prototype.PIC_BASE_URL = 'https://m.haiyanwl.cn/wtcp-file'

/**
 * 机构编码
 * @type {string}
 */
 Vue.prototype.DEPT_CODE = {
    DEPTCODE: '10001000010000200001'
}

/**
 * 地区编码
 * @type {string}
 */
Vue.prototype.AREA_CODE = {
    AREACODE: '632223'
}

Vue.prototype.APP_CODE = {
    APPCODE: '121001'
}

/**
 * 页面title
 * @type {string}
 */
Vue.prototype.PAGE_TITLE = '海晏县-'

/**
 * 微信登录机构编码
 * @type {string}
 */
Vue.prototype.WX_LOGIN_TYPE = 'gwhx'

/**
 *
 * 微信公众号APPID
 * @type {string}
 */
Vue.prototype.WX_APPID = 'wxdab994533543c99a'

/**
 * 收藏类别分类
 * @type {string}
 */
export const XQSC_TYPE_CODE = {
    GL: '1', // 攻略、6202
    YJ: '2', // 游记、6201
    // MDD: '3', // 目的地、
    JQ: '4', // 景区、3001
    LXS: '5', //旅行社、3003
    NJL: '6', // 农家乐、3004
    // ZC: '7', // 租车、3008
    // ZJYD: '8', // 自驾营地、3009
    LYSFC: '9', // 旅游示范村、3010
    CY: '10' //餐饮
}
Vue.prototype.XQSC_TYPE_CODE = XQSC_TYPE_CODE
// /**
//  *
//  * 微信小程序APPID
//  * @type {string}
//  */
// Vue.prototype.WXCX_APPID = 'wxd272daba7c62c547'

/**
 * 微信授权回调地址
 * @type {string}
 */
Vue.prototype.WX_REDIRECT_URI = 'https://m.haiyanwl.cn/#/'



Vue.prototype.FIXED_HOME = true 
/**
 * 拦截器
 */

axios.interceptors.response.use( // 响应拦截
    response => {
        // console.log('响应拦截器：')
        if (response.status === 200) {//正常
            return Promise.resolve(response)
        } else {
            return Promise.reject(response)
        }
    },
    
    error => { //异常
        if (error.response.status === 401) {
            console.log(error.response.status, 'token失效，请重新登录！!');
            bus.$set(bus, 'userInfo', {})
            bus.$set(bus, 'userConfig', {})
            localStorage.removeItem('userInfo')
            localStorage.removeItem('wxUserInfo')
            router.replace("/login");
        }
        return Promise.reject(error.response.status)
    }
)

let historyUrl = ''
let wxBindState = {}
let wxInfo = {}
router.beforeEach((to, from, next) => {
    // 触摸屏页面改变分辨率，通过路由拦截实现
    if (to.meta.fixedWidth) {
        Vue.prototype.co_ver.cover = true
    } else {
        Vue.prototype.co_ver.cover = false
    }
    let userInfo = localStorage.getItem('userInfo')
    // 需要登录权限
    // if (util.isWeiXin() && !userInfo) {

    //     if (to.meta.intercept) {
    //         // 拦截微信授权回调
    //         if (util.getQueryString('state') == 'STATE' && util.getQueryString('code')) {
    //             // 微信登录获取用户信息
    //             Vue.axios.get('/wxauth/wx/loginCheck?code=' + util.getQueryString('code') + '&type=' + Vue.prototype.WX_LOGIN_TYPE).then((response) => {
    //                 const resData = response.data
    //                 if (resData.status === 1) {
    //                     wxInfo = resData.data
    //                     sessionStorage.setItem('wxUserInfo', JSON.stringify(wxInfo))
    //                     // 根据微信unionId微信账号是否绑定
    //                     Vue.axios.get('/api/wtcp-oauth/wx/userRelation/' + wxInfo.unionid + '?deptCode=' + Vue.prototype.DEPT_CODE.DEPTCODE).then((response) => {
    //                         const resData = response.data
    //                         wxBindState = resData
    //                         if (wxBindState.status === 1) {
    //                             if (wxBindState.data.access_token) {
    //                                 bus.$set(bus, 'userInfo', wxBindState.data)
    //                                 sessionStorage.setItem('userInfo', JSON.stringify(wxBindState.data))
    //                                 next()
    //                             } else {
    //                                 next({path: '/relation'})
    //                             }
    //                         } else {
    //                             // 没有绑定手机号
    //                             sessionStorage.setItem('numberNo', true)
    //                             next({path: '/relation'})
    //                         }
    //                     })
    //                 }
    //             })
    //         } else if (!(util.getQueryString('code')) && to.fullPath != '/consultation') { // 微信授权
    //             console.log(util.getQueryString, 222)
    //             if (!sessionStorage.getItem('wxUserInfo')) {
    //                 let userInfo = sessionStorage.getItem('wxUserInfo')
    //                 if (!userInfo || !userInfo.unionid) {
    //                     window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + Vue.prototype.WX_APPID + '&redirect_uri=' + encodeURIComponent(Vue.prototype.WX_REDIRECT_URI + to.fullPath) + '&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect'
    //                 }
    //             } else {
    //                 next()
    //             }
    //         }
    //     } else {
    //         next()
    //     }
    // } else {
        // 获取session用户信息
        if (!bus.userInfo.access_token) {
            let userInfo = localStorage.getItem('userInfo')
            if (userInfo) {
                userInfo = JSON.parse(userInfo)
                if (to.name === 'centerSet') {
                    Vue.axios.get('/api/wtcp-member/public/setup/findByUserId?access_token=' + userInfo.access_token + '&userId=' + userInfo.user.id).then((response) => {
                        const userConfig = response.data.data
                        bus.$set(bus, 'userConfig', userConfig)
                        next()
                    })
                }
                bus.$set(bus, 'userInfo', userInfo)
                next()
            } else {
                bus.$set(bus, 'userInfo', {})
                if (to.meta.intercept) {
                    next({name: 'login'})
                } else {
                    next()
                }
            }
        } else {
            // 登录状态，保存浏览历史到后台服务
            if (bus && bus.history && bus.history.catalog) {
                const param = bus.history
                param.token = bus.userInfo.access_token
                param.deptCode = Vue.prototype.DEPT_CODE.DEPTCODE
                if (historyUrl != param.url) {
                    Vue.axios.post('/api/wtcp-member/public/history?access_token=' + bus.userInfo.access_token, param).then((response) => {
                        if (response.data.msg === 'success') {
                            historyUrl = param.url
                        } 
                    })
                }
            }
            if (bus != undefined && !bus.userConfig && !bus.userConfig.id) {
                Vue.axios.get('/api/wtcp-member/public/setup/findByUserId?access_token=' + bus.userInfo.access_token + '&userId=' + bus.userInfo.user.id).then((response) => {
                    const userConfig = response.data.data
                    bus.$set(bus, 'userConfig', userConfig)
                })
            }
            next()
        }
    // }
    
})